/* src/app/order/pages/order-simple/order-simple.component.scss */
/*# sourceMappingURL=order-simple.component.css.map */
